'use client';
import { createContext, ReactNode } from 'react';
import FF4JClient from '../client/ff4jClient';

export const FF4JContext = createContext<FF4JClient | null>(null);

interface ProviderProps {
  client: FF4JClient;
  children: ReactNode;
}

export const FF4JProvider = ({ client, children }: ProviderProps) => {
  return <FF4JContext.Provider value={client}>{children}</FF4JContext.Provider>;
};
